import React from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/index.js';
import { CheckCircleIcon, ExclamationIcon, InformationCircleIcon, XCircleIcon, } from '../icons/index.js';
export const ToastIcon = ({ status, children }) => {
    let icon;
    const iconClsx = [
        status === 'neutral' && 'text-content-subdued',
        status === 'error' && 'text-content-on-negative',
        status === 'warning' && 'text-content-on-attention',
        status === 'success' && 'text-content-on-positive',
        status === 'info' && 'text-content-on-highlight',
    ];
    switch (status) {
        case 'error':
            icon = React.createElement(XCircleIcon, null);
            break;
        case 'warning':
            icon = React.createElement(ExclamationIcon, null);
            break;
        case 'success':
            icon = React.createElement(CheckCircleIcon, null);
            break;
        case 'info':
            icon = React.createElement(InformationCircleIcon, null);
            break;
        case 'neutral':
            icon = children;
            break;
        default:
            break;
    }
    return icon ? React.createElement(Icon, { className: clsx('h-6 w-6', iconClsx) }, icon) : null;
};
//# sourceMappingURL=ToastIcon.js.map